import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { StaffFunctionsFetchedAction } from '@Application/Facilities/StaffMembers/StaffFunctions/Actions/staffFunctionsFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type StaffFunctionsStore = {
	staffFunctions: readonly LabeledValueView[] | null;
};

const initialState: StaffFunctionsStore = {
	staffFunctions: null,
};

type Actions = StaffFunctionsFetchedAction | UserRevokedAction;

const whenStaffFunctionsFetched = (
	store: StaffFunctionsStore,
	action: StaffFunctionsFetchedAction,
): StaffFunctionsStore => ({
	...store,
	staffFunctions: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): StaffFunctionsStore => initialState;

export default registerStore<'staffFunctionsStore', Actions>(
	'staffFunctionsStore',
	createSliceReducer({
		STAFF_FUNCTIONS_FETCHED: whenStaffFunctionsFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
